/* i18n-disable-file: 路由 meta.title 直接使用中文 key，消费方需在设置 document.title 时调 i18n.t(meta.title) 进行翻译 */
export default [
    {
      path: '/mng/account/contacts/contact',
      name: 'administrator',
      component: () => import('@/pages/mng/information/administrator/index.vue'),
      meta: {
        title: '企业管理员',
        // dataUrl: '/mng/account/embed/indexAjax?embed_type=weisheng',
      },
    },
    {
      path: '/mng/account/corpInfo',
      component: () => import('@/pages/mng/information/corpInfo/index.vue'),
      meta: {
        title: '企业资料',
      },
    },
  ];
